<template>
  <div class="elevatorDetail">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回上一级</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws13"
        :label-suffix="require('@/config/enum').c_colon">
        <el-card class="form wid100 mb30">
          <div class="infoTitle">基础信息</div>
          <el-form-item tem label="出厂编号" prop="Factorynum">
            <el-input type="text" v-model="ruleForm.Factorynum" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="注册代码" prop="Registercode">
            <el-input type="text" v-model="ruleForm.Registercode" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="安装位置" prop="Place">
            <el-input type="text" v-model="ruleForm.Place" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="所在城市" prop="cityName">
            <el-input type="text" v-model="ruleForm.cityName" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="所属区域" prop="districtName">
            <el-input type="text" v-model="ruleForm.districtName" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="使用状态" prop="State">
            <el-input v-if="ruleForm.State==0" type="text" value="在线" disabled class="item-input"></el-input>
            <el-input v-if="ruleForm.State==1" type="text" value="调试" disabled class="item-input"></el-input>
            <el-input v-if="ruleForm.State==2" type="text" value="下线" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="电梯类型" prop="DevName">
            <el-input type="text" v-model="ruleForm.DevName" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="电梯品牌" prop="Brand">
            <el-input type="text" v-model="ruleForm.Brand" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="电梯型号" prop="Devmodel">
            <el-input type="text" v-model="ruleForm.Devmodel" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="使用登记证编号" prop="Certificateid">
            <el-input type="text" v-model="ruleForm.Certificateid" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="投入使用日期" prop="Usedate">
            <el-input type="text" v-model="ruleForm.Usedate" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="经度" prop="Longitude">
            <el-input type="text" v-model="ruleForm.Longitude" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="纬度" prop="Latitude">
            <el-input type="text" v-model="ruleForm.Latitude" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item style="opacity:0" tem label="" prop="">
            <el-input type="text" v-model="ruleForm.beVisitPhone" disabled class="item-input"></el-input>
          </el-form-item>
        </el-card>
        <el-card class="form wid100 mb30">
          <div class="infoTitle">使用信息</div>
          <el-form-item tem label="使用单位" prop="Useunitidname">
            <el-input type="text" v-model="ruleForm.Useunitidname" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="维保单位" prop="Makeunitname">
            <el-input type="text" v-model="ruleForm.Makeunitname" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="联系人" prop="DutyPersonName">
            <el-input type="text" v-model="ruleForm.DutyPersonName" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="联系人" prop="Maintanman">
            <el-input type="text" v-model="ruleForm.Maintanman" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="联系电话" prop="DutyPersonPhone">
            <el-input type="text" v-model="ruleForm.DutyPersonPhone" disabled class="item-input"></el-input>
          </el-form-item>
          <el-form-item tem label="联系电话" prop="Cqphone">
            <el-input type="text" v-model="ruleForm.Cqphone" disabled class="item-input"></el-input>
          </el-form-item>
        </el-card>
        <el-card class="form wid100 mb30">
          <div class="infoTitle">物联网设备绑定</div>
          <el-form-item tem label="【主设备】电梯AI梯智终端" prop="Useunitidname" style="width:300px">
            <p style="color:#00b1c3;">{{ruleForm.Useunitidname}}{{ruleForm.Name}}</p>
          </el-form-item>
        </el-card>
        <el-card class="form wid100 mb30 operations">
          <div class="infoTitle">更多操作</div>
          <el-form-item tem label="重启设备">
            <el-button type="primary" @click="handleClick(1)">重启设备</el-button>
          </el-form-item>
          <el-form-item tem label="同步北京时间">
            <el-button type="primary" @click="handleClick(2)">同步北京时间</el-button>
          </el-form-item>
          <el-form-item tem label="设备参数读取">
            <el-button type="primary" @click="deviceRead()">设备参数读取</el-button>
          </el-form-item>
          <el-form-item tem label="电瓶车阻梯参数读取">
            <el-button type="primary" @click="cableCarRead()">电瓶车阻梯参数读取</el-button>
          </el-form-item>
          <el-form-item tem label="电梯开关门参数读取">
            <el-button type="primary" @click="doorRead()">电梯开关门参数读取</el-button>
          </el-form-item>
        </el-card>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
          <span>{{ title }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="config">确 定</el-button>
          </span>
        </el-dialog>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:elevatorDetail
   *@Description:电梯详情
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        ruleForm: {},
        title: '',
        flag: '',
        dialogVisible: false,
      }
    },
    computed: {
      ...mapGetters(['gardenId']),
    },
    created() {
      this.getData()
    },
    watch: {

    },
    methods: {

      // 获取电梯详情数据
      getData() {
        this.ruleForm = this.$route.query.object
        console.log(this.ruleForm)
        console.log(this.ruleForm.Registercode)
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'realTimeMonitoringList',
        })
      },
      handleClick(e) {
        if (e == 1) {
          this.flag = 1
          this.title = '确定执行【重启设备】操作吗？'
        } else if (e == 2) {
          this.flag = 2
          this.title = '确定执行【同步北京时间】操作吗？'
        }
        this.dialogVisible = true
      },
      config(e) {
        if (this.flag == 1) {
          this.restart()
        } else if (this.flag == 2) {
          this.syncTime()
        }
        this.dialogVisible = false
      },
      // 重启设备
      restart() {
        let loading = this.$loading()
        this.$postJson(`aapi/liftReboot`, {
          'token': 'zlj365',
          'regcode': this.ruleForm.Registercode,
        }).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.$message.success('设备重启成功')
            } else {
              this.$message.error(res.errCode)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 同步北京时间
      syncTime() {
        let loading = this.$loading()
        this.$postJson(`aapi/setLiftTime`, {
          'token': 'zlj365',
          'regcode': this.ruleForm.Registercode,
          'EnableModel': new Date().getTime()
        }).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {

            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 设备参数读取
      deviceRead() {
        this.$router.push({
          name: 'deviceRead',
          query: {
            object: this.ruleForm
          }
        })
        // let loading = this.$loading()
        // this.$postJson(`aapi/getLiftDeviceList`, {
        //   'token': 'zlj365',
        //   'regcode': this.ruleForm.Registercode
        // }).then(
        //   res => {
        //     loading.close()
        //     console.log(res)
        //     if (res && res.errCode === 0) {

        //     }
        //   },
        //   error => {
        //     loading.close()
        //     this.$message.error(error)
        //   })
      },
      // 电瓶车阻梯参数读取
      cableCarRead() {
        this.$router.push({
          name: 'cableCarRead',
          query: {
            object: this.ruleForm
          }
        })
      },
      // 电梯开关门参数读取
      doorRead() {
        this.$router.push({
          name: 'doorRead',
          query: {
            object: this.ruleForm
          }
        })
      },
      handleClose() {
        this.dialogVisible = false
      }

    },
  }
</script>

<style lang="scss">
  .elevatorDetail {
    .el-form {
      padding: 0 50px;
      box-sizing: border-box;
    }

    .form {
      .el-card {
        margin-bottom: 30px;
        padding: 0;
      }

      .el-card__body {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .infoTitle {
        flex: 100% !important;
        padding: 20px;
        background-color: #edf4fb;
        font-size: 18px;
        color: #00b1c3;
        margin-bottom: 20px;
      }

      .el-form-item {
        flex: 1 0 50%;
        align-items: center;
      }

    }

    .item-input {
      width: 50%;
    }

    .mb30 {
      margin-bottom: 30px;
      padding: 0;
    }

    .el-input.is-disabled .el-input__inner {
      color: #606266;
    }

    .el-dialog__body {
      padding: 20px !important;
    }

    // .operations .el-form-item__label{
    //   width: 150px!important;
    // }
    // .operations .el-form-item__content{
    //   margin-left: 150px!important;
    // }
  }
</style>